import React from 'react';
import styled from '@emotion/styled';
import { PrimaryButton } from '../../buttons/PrimaryButton';

const ModalBody = styled.div`
  background: #fff;
  padding: 10px 2rem;
  display: flex;
  flex-direction: column;
`;

const ButtonLayout = styled.div`
  display: flex;
  justify-content: flex-end;
`;

interface Props {
  closeFn: () => void;
}

const RetryModal = (props: Props) => {
  return (
    <ModalBody>
      Retry for this project has been initiated.
      <ButtonLayout>
        <PrimaryButton clickFn={props.closeFn}>Ok</PrimaryButton>
      </ButtonLayout>
    </ModalBody>
  );
};

export default RetryModal;
